'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import ImmutablePropTypes from 'react-immutable-proptypes';
import FormattedList from 'I18n/components/FormattedList';

const AppIntegrations = ({
  integrations
}) => /*#__PURE__*/_jsx(FormattedList, {
  children: integrations.sort().map(integration => /*#__PURE__*/_jsx("span", {
    children: integration
  }, integration)).toArray()
});

AppIntegrations.propTypes = {
  integrations: ImmutablePropTypes.set.isRequired
};
export default AppIntegrations;